import { get, omit } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { RelatedParty } from '@funnels/types';

export const getAccountantCopy = (relatedParties: RelatedParty[], fromIndex: number, toIndex: number): RelatedParty => {
  const original = relatedParties[toIndex];
  const from = relatedParties[fromIndex];
  const id = get({ relatedParties: [original] }, FIELD_PATHS.RELATED_PARTY_ID(0));
  const employmentId = get({ relatedParties: [original] }, FIELD_PATHS.RELATED_PARTY_EMPLOYMENT_ID(0));
  const clientId = get({ relatedParties: [original] }, FIELD_PATHS.RELATED_PARTY_CLIENT_ID(0));
  const applicationId = get({ relatedParties: [original] }, FIELD_PATHS.RELATED_PARTY_APPLICATION_ID(0));
  return {
    ...omit(from, ['id', 'createdAt', 'isDeidentified', 'isDeleted']),
    ...(!!id && { id }),
    employmentId,
    clientId,
    applicationId,
  };
};
